"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndexProfileRequests = void 0;
const Paths_1 = require("../Paths");
const Utils_1 = require("../Utils");
const IndexUtils_1 = require("./IndexUtils");
const OptionsHandler_1 = require("./IndexUtils/OptionsHandler");
const TaskRequests_1 = require("./TaskRequests");
class IndexProfileRequests {
    constructor(session, uuid, appInfo) {
        this.session = session;
        this.uuid = uuid;
        this.appInfo = appInfo;
        const opts = new OptionsHandler_1.OptionsHandler(this.appInfo);
        this.taskReq = new TaskRequests_1.TaskRequests(this.session, uuid, opts);
    }
    getIndexProfileRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const opts = new OptionsHandler_1.OptionsHandler(this.appInfo);
            const options = {
                method: Paths_1.Methods.GET,
            };
            const request = yield (0, Utils_1.buildGenericRequest)(this.session, options, opts);
            const endpoint = this.getRootIndexEndpoint();
            const rawIndexProfile = yield (0, Utils_1.wrapFetchJson)(request, endpoint);
            return (0, IndexUtils_1.cleanIndexWrapper)(rawIndexProfile);
        });
    }
    getIndexProfile() {
        return __awaiter(this, void 0, void 0, function* () {
            const rawIndexProfile = yield this.getIndexProfileRaw();
            return (0, IndexUtils_1.wrapIndexProfile)(rawIndexProfile, this.uuid);
        });
    }
    getRootIndexEndpoint() {
        return `${this.session.baseUrl}/profiles/${this.uuid}`;
    }
}
exports.IndexProfileRequests = IndexProfileRequests;
//# sourceMappingURL=IndexProfileRequests.js.map